// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ebeb8d8","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/opt/buildhome/repo/src/configs/scss/config.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/parts/components/newLogo.vue
// module id = kbU6
// module chunks = 1